module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average number of blocks found every hour.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("BTC")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '3h', 3 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '6h', 6 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '12h', 12 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '1d', 24 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BTC', '7d', 7 * 24 * 60)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BCH")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '3h', 3 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '6h', 6 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '12h', 12 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '1d', 24 * 60)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.blocks_hr('BCH', '7d', 7 * 24 * 60)))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "644px"
    },
    attrs: {
      "id": "canvas-blocktime"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _c('th', [_vm._v("3h")]), _vm._v(" "), _c('th', [_vm._v("6h")]), _vm._v(" "), _c('th', [_vm._v("12h")]), _vm._v(" "), _c('th', [_vm._v("1d")]), _vm._v(" "), _c('th', [_vm._v("7d")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41952575","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/blocktime.vue
// module id = 538
// module chunks = 1